// Base
import Image, { StaticImageData } from 'next/image'

// Components
import { Box, Text, Flex } from 'yard-utilities/components'
import Tag from '@components/v25/common/tag/Tag'

// Redux
import { useAppSelector } from '@redux/hooks'

// Styles
import styles from './ExperienceCard.module.sass'
import { displayExchangedPrice } from '@helpers/exchangeRate'

interface RecentDealCardProps {
  img: string | StaticImageData
  destination: string
  date: string
  prices: { old: number; new: number }
}

const ExperienceCard = ({
  img,
  destination,
  date,
  prices
}: RecentDealCardProps) => {
  const { exchangeRate, currency, currencyLoaded } = useAppSelector(
    (state) => state.visitor
  )

  return (
    <Box className={styles.container}>
      <Image
        src={img}
        alt={`Photo of ${destination}`}
        fill
        sizes="100%"
        priority
        placeholder="blur"
        className={styles.image}
      />

      <Box
        borderRadius={{ sm: [8, 8, 8, 0] }}
        padding={{ sm: [12] }}
        backgroundColor="yellow-10"
        shadow="shadowDefault"
        className={styles.labelBox}
      >
        <Text tagName="h4" variant="title-3" spacing={{ sm: 4 }}>
          {destination}
        </Text>

        <Text
          tagName="p"
          variant="body-5"
          textColor="grey-2"
          spacing={{ sm: 4 }}
        >
          {date}
        </Text>

        <Text
          tagName="p"
          variant="body-3"
          spacing={{ sm: 8 }}
          className={styles.text}
        >
          Oferta de ida y vuelta
        </Text>

        <Flex alignItems="center" columnGap={{ sm: 4 }}>
          <Text
            tagName="p"
            variant="body-1"
            align="center"
            fontWeight={500}
            textColor="red"
            decoration="lineThrough"
          >
            {displayExchangedPrice({
              value: prices.old,
              exchangeRate,
              currency,
              loaded: currencyLoaded
            })}
          </Text>

          <Tag
            variant="type-4"
            backgroundColor="yellow"
            textColor="black"
            textSize="title-4"
            fontWeight={700}
          >
            {displayExchangedPrice({
              value: prices.new,
              exchangeRate,
              currency,
              loaded: currencyLoaded
            })}
          </Tag>
        </Flex>

        <div className={styles.labelFold} />
      </Box>
    </Box>
  )
}

export default ExperienceCard
